export const cloneObject = (state) => {
    return JSON.parse(JSON.stringify(state));
}
